import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

export const {
  height: $height,
  fontWeight: $fontWeight,
  fontSize: $fontSize,
  textTransform: $textTransform,
  letterSpacing: $letterSpacing,
  color: $color,
  backgroundColor: $backgroundColor,
  paddingX: $paddingX,
  paddingY: $paddingY,
} = defineCssVars(`th`, [
  `height`,
  `fontWeight`,
  `fontSize`,
  `textTransform`,
  `padding`,
  `letterSpacing`,
  `color`,
  `backgroundColor`,

  `paddingX`,
  `paddingY`,
]);

export const thCssVars = (props: StyleFunctionProps) => ({
  [$height.variable]: `sizes.40`,
  [$fontWeight.variable]: `fontWeights.medium`,
  [$fontSize.variable]: `fontSizes.sm`,
  [$textTransform.variable]: `none`,
  [$letterSpacing.variable]: `normal`,
  [$color.variable]: mode(`colors.gray.500`, `colors.whiteAlpha.700`)(props),
  [$paddingX.variable]: `space.24`,
  [$paddingY.variable]: `space.8`,
});

export const thStyle = defineStyleConfig({
  baseStyle: (_props: StyleFunctionProps) => ({
    // TODO: move to component that contains

    position: `relative`,
    // Size
    height: $height.reference,

    // Spacing
    padding: `${$paddingY.reference} ${$paddingX.reference}`,

    // Typography
    fontWeight: $fontWeight.reference,
    fontSize: $fontSize.reference,
    textTransform: $textTransform.reference,
    letterSpacing: $letterSpacing.reference,
    color: $color.reference,

    // overrides
    paddingInlineEnd: `0`,
    paddingInlineStart: `0`,
    paddingTop: `unset`,
    paddingBottom: `unset`,

    [`&[data-name="selection"] [aria-selected="false"]`]: {
      visibility: `hidden`,
    },
    [`&[data-name="selection"]:hover [aria-selected]`]: {
      visibility: `visible`,
    },
  }),
  sizes: {
    sm: {
      fontSize: $fontSize.reference,
    },
    md: {
      fontSize: $fontSize.reference,
    },
    lg: {
      fontSize: $fontSize.reference,
    },
  },
});
